<template>
  <div>
    <!-- NAZIV -->
    <div class="section dropdown">
      <div class="form-group required" aria-required="true">
          <label for="title" v-html="$store.state.texts.user.gender.title"></label>
          <div class="custom-selectbox">
              <select name="title" id="title" v-model="$store.state.form.user.title" @change="$store.state.validation.title = true">
                  <option class="selected-value" selected="selected"  disabled="disabled" v-html="$store.state.texts.user.gender.select"></option>
                  <option v-for="(title, index) in $store.state.dropdowns.titles" :key="index">{{ title }}</option>
              </select>
              <span class="selectedValue" v-if="$store.state.form.user.title === ''" :class="{isInvalid: !$store.state.validation.title && $store.state.submitted}" v-html="$store.state.texts.user.gender.select"></span>
              <span class="selectedValue" v-else :class="{isInvalid: !$store.state.validation.title && $store.state.submitted}">{{ $store.state.form.user.title }}</span>
              <span class="error-message" v-if="!$store.state.validation.title && $store.state.submitted" v-html="$store.state.texts.user.gender.error"></span>
          </div>
      </div>
    </div>
    <!-- IME -->
    <div class="textfield section">
      <div class="form-group required" aria-required="true">
        <label for="name" v-html="$store.state.texts.user.name.title"></label>
        <div class="form-group-container">
            <input id="name" name="name" v-model="name" required="" type="text" :class="{isInvalid: $v.name.$error || ($store.state.submitted && !$store.state.validation.name)}" @blur="$v.name.$touch()" @input="fieldValidations($v.name.$invalid, 'name')">
            <span class="error-message" v-if="$v.name.$error || ($store.state.submitted && !$store.state.validation.name)" v-html="$store.state.texts.user.name.error"></span>
        </div>
      </div>
    </div>
    <!-- PRIIMEK -->
    <div class="textfield section">
      <div class="form-group required">
        <label for="last-name" v-html="$store.state.texts.user.lastName.title"></label>
        <div class="form-group-container">
          <input id="last-name" name="last-name" v-model="last_name" type="text" :class="{isInvalid: $v.last_name.$error || ($store.state.submitted && !$store.state.validation.lastName)}" @blur="$v.last_name.$touch(), fieldValidations($v.last_name.$invalid, 'lastName')" @input="fieldValidations($v.last_name.$invalid, 'lastName')">
          <span class="error-message" v-if="$v.last_name.$error || ($store.state.submitted && !$store.state.validation.lastName)" v-html="$store.state.texts.user.lastName.error"></span>
        </div>
      </div>
    </div>
    <!-- BUSINESS -->
    <!-- <div class="textfield section">
      <div class="form-group">
        <label for="business" v-html="$store.state.texts.user.business.title"></label>
        <div class="form-group-container">
          <input id="business" name="business" v-model="$store.state.form.user.business" type="text">
        </div>
      </div>
    </div> -->
    <!-- EMAIL -->
    <div class="textfield section">
      <div class="form-group required">
        <label for="email" v-html="$store.state.texts.user.email.title"></label>
        <div class="form-group-container">
          <input id="email" name="email" v-model="email" type="email" :class="{isInvalid: $v.email.$error || ($store.state.submitted && !$store.state.validation.email)}" @blur="$v.email.$touch(), fieldValidations($v.email.$invalid, 'email')" @input="fieldValidations($v.email.$invalid, 'email')">
          <span class="error-message" v-if="$v.email.$error || ($store.state.submitted && !$store.state.validation.email)" v-html="$store.state.texts.user.email.error"></span>
        </div>
      </div>
    </div>
    <!-- Telefon 
    <div class="textfield section">
      <div class="form-group">
        <label for="telephone" v-html="$store.state.texts.user.telephone.title"></label>
        <div class="form-group-container">
          <input id="telephone" name="telephone" v-model="telephone" type="text" :class="{isInvalid: $v.telephone.$error || (!$store.state.validation.telephone)}" @input="fieldValidations($v.telephone.$invalid, 'telephone')">
          <span class="error-message" v-if="$v.telephone.$error || (!$store.state.validation.telephone)" v-html="$store.state.texts.user.telephone.error"></span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { required, email, numeric, minLength, maxLength } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
    }
  },
  computed: {
    // TWO WAY DATA BINDING FOR USER NAME
    name: {
      get () {
        return this.$store.getters.name
      },
      set (value) {
        this.$store.commit('updateName', value)
      }
    },
    last_name: {
      get () {
        return this.$store.getters.last_name
      },
      set (value) {
        this.$store.commit('updateLastName', value)
      }
    },
    email: {
      get () {
        return this.$store.getters.email
      },
      set (value) {
        this.$store.commit('updateEmail', value)
      }
    },
    telephone: {
      get () {
        return this.$store.getters.telephone
      },
      set (value) {
        this.$store.commit('updateTelephone', value)
      }
    },
  },
  validations: {
    name: {
      required
    },
    last_name: {
      required
    },
    email: {
      required,
      email
    },
    telephone: {
      required
    },
  },
  methods: {
    fieldValidations (validation, storeObj) {  
      if (storeObj === "telephone" || storeObj !== "telephone" && validation === false) {
        this.$store.state.validation[storeObj] = true
      } else {
        this.$store.state.validation[storeObj] = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
     .custom-selectbox {
         width: 100% !important;
         max-width: 100% !important;
     }
     .selectedValue::after {
        border-left: 2px solid #eee;
        padding-left: .7142857143em;
        padding-right: .7142857143em;
        color: #c3002f;
        font-size: 1.1428571429em;
        line-height: 1.6;
        right: 0;
        margin-top: .125em;
     }
     //ERROR HANDLING
    .isInvalid {
      border: 2px solid red!important;
    }
    input.isInvalid::placeholder {
      color: red;
    }
    .error-message {
      display: block;
      color: red;
    }
</style>



// WEBPACK FOOTER //
// src/components/form/User.vue